<template>
  <div class="hello">
    <div class="col-sm-12">
      <div class="element-wrapper">
        <div class="element-actions">
          <form class="form-inline justify-content-sm-end">
            <label class="smaller" for="">Provider</label>
            <select class="form-control form-control-sm form-control-faded" v-model="provider">
              <option v-for="option in providers" v-bind:value="option.value">
                {{ option.label }}
              </option>
            </select>
            <label class="smaller" for="">Order By</label>
            <select class="form-control form-control-sm form-control-faded" v-model="period">
              <option v-for="option in periods" v-bind:value="option.value">
                {{ t.filter.accounting[option.value] }}
              </option>
            </select>
          </form>
        </div>
        <h6 class="element-header">Casino Overview</h6>
        <div class="element-content">
          <div class="row">
            <div class="col-sm-6 col-xxxl-4">
              <a class="element-box el-tablo" href="#">
                <div class="label">{{ t.navigation.total_amount_of_wager }}</div>
                <div class="value">{{ result.wager | toMoney(currency)  }}</div>
              </a>
            </div>
            <div class="col-sm-6 col-xxxl-4">
              <a class="element-box el-tablo" href="#">
                <div class="label">{{ t.betting.title.winning_bets }}</div>
                <div class="value">{{ result.won | toMoney(currency)  }}</div>
              </a>
            </div>
            <div class="col-sm-12 col-xxxl-4">
              <a class="element-box el-tablo" href="#">
                <div class="label">{{ t.navigation.total_profit }}</div>
                <div class="value">{{ result.profit | toMoney(currency) }}</div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'casinoOverview',
        data () {
            return {
                result: null,
                currency: null,
                t: this.$root.t,
                provider: '*',
                providers: [
                    {label: 'All', value: '*'},
                    {label: 'Slots', value: 'SLOTS'},
                    {label: 'Live Tombola', value: 'LIVE_TOMBOLA'},
                    {label: 'Evolution', value: 'EVOLUTION'},
                    {label: 'VIVO Gaming', value: 'Vivo_Gaming'},
                    {label: 'Ezugi', value: 'EZUGI'}
                ],
                period: 'today',
                periods: [
                    { label: 'Today', value: 'today' },
                    { label: 'Yesterday', value: 'yesterday' },
                    { label: 'This Week', value: 'this_week' },
                    { label: 'This Month', value: 'this_month' },
                    { label: 'Q1', value: 'q1' },
                    { label: 'Q2', value: 'q2' },
                    { label: 'Q3', value: 'q3' },
                    { label: 'Q4', value: 'q4' },
                    { label: 'Financial First Half', value: 'first_financial_half' },
                    { label: 'Financial Second Half', value: 'second_financial_half' },
                ]
            }
        },
        watch: {
            period () {
                this.fetchOverview();
            },
            provider () {
                this.fetchOverview();
            }
        },
        mounted () {
            this.fetchOverview();
        },
        methods: {
            fetchOverview () {
                this.$http.get(api+'api/v1/analytics/casino/overview', {params: {period: this.period, provider: this.provider} } ).then(response => {

                    this.result = response.body.result.slice(-1).pop();
                    this.currency = response.body.currency;
                }, response => {

                })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/casino/overview.vue